import { render, staticRenderFns } from "./LmDocumentMovements.vue?vue&type=template&id=387c75d5&scoped=true&"
import script from "./LmDocumentMovements.vue?vue&type=script&lang=js&"
export * from "./LmDocumentMovements.vue?vue&type=script&lang=js&"
import style0 from "./LmDocumentMovements.vue?vue&type=style&index=0&id=387c75d5&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387c75d5",
  null
  
)

export default component.exports